// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../../../../types";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetEnquiryDetailsEventTypeQueryVariables = Types.Exact<{
  id: Types.Scalars["String"];
}>;

export type GetEnquiryDetailsEventTypeQuery = {
  __typename?: "Query";
  collection: { __typename?: "Collection"; id: string; name: string };
};

export type EnquiryDetailsEventTypeFragment = {
  __typename?: "Collection";
  id: string;
  name: string;
};

export type BookingEnquiryDetailsEventFragment = {
  __typename?: "Event";
  fromDateTime: string;
  toDateTime: string;
  budget: number;
  currency: string;
  attendees: number;
  location: string;
  cateringNeeds?: string | null;
  additionalNotes?: string | null;
  layoutID: string;
  radius?: string | null;
  flexibleWithDates: boolean;
  flexibleWithDatesNote?: string | null;
  eventType: { __typename?: "Collection"; id: string };
  spaceFacilities?: Array<{
    __typename?: "SpaceFacility";
    id: number;
    name: string;
  }> | null;
  styles?: Array<{
    __typename?: "Style";
    id?: Types.StyleId | null;
    label?: string | null;
  }> | null;
};

export const EnquiryDetailsEventTypeFragmentDoc = gql`
  fragment EnquiryDetailsEventType on Collection {
    id
    name
  }
`;
export const BookingEnquiryDetailsEventFragmentDoc = gql`
  fragment BookingEnquiryDetailsEvent on Event {
    eventType {
      id
    }
    fromDateTime
    toDateTime
    budget
    currency
    attendees
    location
    spaceFacilities {
      id
      name
    }
    cateringNeeds
    additionalNotes
    layoutID
    styles {
      id
      label
    }
    radius
    flexibleWithDates
    flexibleWithDatesNote
  }
`;
export const GetEnquiryDetailsEventTypeDocument = gql`
  query GetEnquiryDetailsEventType($id: String!) {
    collection(id: $id) {
      ...EnquiryDetailsEventType
    }
  }
  ${EnquiryDetailsEventTypeFragmentDoc}
`;

export function useGetEnquiryDetailsEventTypeQuery(
  options: Omit<
    Urql.UseQueryArgs<GetEnquiryDetailsEventTypeQueryVariables>,
    "query"
  >
) {
  return Urql.useQuery<GetEnquiryDetailsEventTypeQuery>({
    query: GetEnquiryDetailsEventTypeDocument,
    ...options,
  });
}
